import { render, staticRenderFns } from "./BMenuGroupDetail.vue?vue&type=template&id=0266f3a6&scoped=true&"
import script from "./BMenuGroupDetail.vue?vue&type=script&lang=js&"
export * from "./BMenuGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./BMenuGroupDetail.vue?vue&type=style&index=0&id=0266f3a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266f3a6",
  null
  
)

export default component.exports